import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  Button,
} from "@material-tailwind/react";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
  // httpsCallable,
} from "firebase/functions";
import {
  collection,
  limit,
  orderBy,
  query,
} from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import db from "../../firebase";
import {formatFirebaseTimestamp} from '../../utils';

export function FXRateView() {
  const options = {
    snapshotListenOptions: { includeMetadataChanges: true },
  };

  const queryData = query(
    collection(db, "fx_rates_daily"),
    orderBy("tsUploaded","desc"), limit(200)
  );
  
  const [listingsValue] = useCollection(queryData, options);
  
  // console.log(listingsValue?.docs.map((m)=>m.data()))

  const functions = getFunctions();
  if (window.location.href.indexOf("localhost") > -1) {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  }

  const handleUpdateFX = () =>{
    const func = httpsCallable(functions, "updateFXRates");
    func().then((data)=>{
      console.log("save the rates");
    }).catch((e)=>{
      console.error(e)
    })
  }
  
  return (
    <>
    
    <div className="flex gap-2">

    <Button onClick={()=>handleUpdateFX()}>Update FX</Button>      
        
    </div>

    <div className="mt-12 mb-8 flex flex-col gap-12">
      <Card>
        <CardHeader className="bg-[#041c2c]">
          <div className="flow-root">
            <Typography variant="h6" color="white" className="float-left">
              FX Rates
            </Typography>
        
          </div>
        </CardHeader>
        <CardBody className="overflow-x-scroll px-0 pt-0 pb-2">
          {/* <div className="w-full min-w-[640px]">
            <Typography variant="h6" color="pink">
              You are looking at page: {page}, total count {listingsCount}
            </Typography>
          </div> */}

          <table className="w-full min-w-[640px] table-auto">
            <thead>
              <tr>
                {[
                  "Date",
                  "Uploaded", 
                  "USD/EUR", 
                  "USD/GBP"
                ].map((el) => (
                  <th
                    key={el}
                    className="border-b border-gray-200 py-3 px-5 text-left"
                  >
                    <Typography
                      variant="small"
                      className="text-[11px] font-bold uppercase text-lma-gray"
                    >
                      {el}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {listingsValue &&
                listingsValue.docs.map((doc, index) => {
                  const className = `py-3 px-5 ${
                    index === listingsValue.docs.length - 1
                      ? ""
                      : "border-b border-gray-200"
                  }`;

                  return (
                    <tr key={`row${index}`}>
                      
                      <td className={className}>
                        <Typography
                          variant="small"
                          className="text-xs font-medium text-lma-gray"
                        >
                          {doc.id}
                        </Typography>
                      </td>

                      <td className={className}>
                        <Typography
                          variant="small"
                          className="text-xs font-medium text-lma-gray"
                        >
                          { formatFirebaseTimestamp(doc.data().tsUploaded)}
                        </Typography>
                      </td>

                      <td className={className}>
                        <Typography
                          variant="small"
                          className="text-xs font-medium text-lma-gray"
                        >
                          { 1 / doc.data().rates["EUR"]}
                        </Typography>
                      </td>

                      <td className={className}>
                        <Typography
                          variant="small"
                          className="text-xs font-medium text-lma-gray"
                        >
                          { 1 / doc.data().rates["GBP"]}
                        </Typography>
                      </td>


                    </tr>
                  );
                })}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
    
    </>
  );
}

export default FXRateView
